<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h2"><a id="page_5"></a>Contents</h1>
<h2 class="toc"><a href="#/xhtml/05_ack">Acknowledgements</a></h2>
<h2 class="toc"><a href="#/xhtml/06_intro">Introduction</a></h2>
<h2 class="toc1"><span href="#/xhtml/07_chap01" title="Link target outside of Sample"><span class="f_toc">Chapter 1</span> Mike Sharman - A Pioneer Modeller of Early Railways</span></h2>
<h2 class="toc1"><span href="#/xhtml/08_chap02" title="Link target outside of Sample"><span class="f_toc">Chapter 2</span> Infrastructure</span></h2>
<h2 class="toc1"><span href="#/xhtml/09_chap03" title="Link target outside of Sample"><span class="f_toc">Chapter 3</span> Locomotives</span></h2>
<h2 class="toc1"><span href="#/xhtml/10_chap04" title="Link target outside of Sample"><span class="f_toc">Chapter 4</span> Carriages</span></h2>
<h2 class="toc1"><span href="#/xhtml/11_chap05" title="Link target outside of Sample"><span class="f_toc">Chapter 5</span> Wagons</span></h2>
<h2 class="toc1"><span href="#/xhtml/12_chap06" title="Link target outside of Sample"><span class="f_toc">Chapter 6</span> Layouts and models</span></h2>
<h2 class="toc1"><span href="#/xhtml/13_appendix" title="Link target outside of Sample"><span class="f_toc">Appendix</span> Sources of supply for modellers</span></h2>
<h2 class="toc"><span href="#/xhtml/14_bib" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3b1c892b